import { ShoppingBag, DollarSign, Users, Wallet } from "lucide-react";

const iconMap = {
  "shopping-bag": ShoppingBag,
  dollar: DollarSign,
  users: Users,
  wallet: Wallet,
};

type QuickStatsListProps = {
  stats: QuickStat[];
};

export function QuickStatsList({ stats }: QuickStatsListProps) {
  return (
    <div className="flex w-[200px] shrink-0 flex-col justify-center gap-4">
      {stats.map(({ id, label, value, iconName, bg, color }) => {
        const Icon = iconMap[iconName];
        return (
          <div key={id} className="flex items-center gap-3">
            <div
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${bg}`}
            >
              <Icon size={18} className={color} strokeWidth={1.75} />
            </div>
            <div>
              <p className="text-xs text-muted">{label}</p>
              <p className="text-sm font-bold text-foreground">{value}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
